import { render, staticRenderFns } from "./PlusButton.vue?vue&type=template&id=17b0d970&scoped=true"
import script from "./PlusButton.vue?vue&type=script&lang=js"
export * from "./PlusButton.vue?vue&type=script&lang=js"
import style0 from "./PlusButton.vue?vue&type=style&index=0&id=17b0d970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b0d970",
  null
  
)

export default component.exports